import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'auto-question-modal-tab',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, NgClass],
  template: `
    <div
      class="e11-border e11-rounded-b-none e11-border-skin-primary-accent e11-rounded-lg e11-p-4 e11-max-h-24"
      [ngClass]="{
        'e11-bg-skin-grey/10': !isActive,
        'e11-border-b-0': isActive,
        'e11-border-l-0': isFirst,
        'e11-border-r-0': isLast || hasSibling
      }"
    >
      <div class="e11-flex e11-gap-2 e11-mb-2 e11-items-center">
        <span class="material-icons-outlined" [ngClass]="{ 'e11-text-skin-primary-accent': !isActive }">{{ icon }}</span>
        <span class=" e11-font-primary-bold" [ngClass]="{ 'e11-text-skin-primary-accent': !isActive }"> {{ title | translate }}</span>
      </div>
      <p class="e11-text-sm" [ngClass]="{ 'e11-text-skin-grey e11-font-primary-medium': isActive, 'e11-text-skin-primary-accent': !isActive }">
        <ng-content></ng-content>
      </p>
    </div>
  `,
  styles: ``,
})
export class AutoQuestionModalTabComponent {
  @Input({ required: true }) isActive!: boolean
  @Input({ required: true }) title!: string
  @Input() isLast: boolean = false
  @Input() isFirst: boolean = false
  @Input() hasSibling: boolean = false
  @Input() icon: string = 'task_alt'
}
